// Service.js
import React, { useRef } from 'react';
import './Service.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ServicePage = () => {
    // ========== DATA START ==========

    // Main Services Data
    const mainServices = [
        {
            id: 1,
            title: "Web Design & Development",
            description: "Transform your online presence with our expert Web Design & Development solutions, tailored to elevate your brand and engage your audience effectively.",
            features: ["Responsive Design", "Custom CMS", "SEO Optimized", "Fast Loading"],
            icon: (
                <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                    <path d="M2 10h20"></path>
                </svg>
            )
        },
        {
            id: 2,
            title: "Mobile Application",
            description: "Smartphone's are being used on a regular basis and most of the users engaged on smart phones. To elevate your business presence.",
            features: ["iOS & Android", "Cross Platform", "UI/UX Design", "App Store Deployment"],
            icon: (
                <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                    <line x1="12" y1="18" x2="12.01" y2="18"></line>
                    <path d="M12 22h.01"></path>
                    <circle cx="12" cy="6" r="1"></circle>
                </svg>
            )
        },
        {
            id: 3,
            title: "E-Commerce",
            description: "E-commerce revolutionizes shopping, bridging global markets with a click. From gadgets to groceries, it's the digital marketplace's slick.",
            features: ["Payment Gateway", "Inventory Management", "Order Tracking", "Secure Checkout"],
            icon: (
                <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
            )
        },
        {
            id: 4,
            title: "Software Development",
            description: "We specializes in software development in all domains & technologies With a dedicated team of experienced developers.",
            features: ["Custom Software", "Cloud Solutions", "API Integration", "Agile Development"],
            icon: (
                <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                    <polyline points="2 17 12 22 22 17"></polyline>
                    <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
            )
        },
        {
            id: 5,
            title: "PR & Marketing",
            description: "Elevate your brand's visibility and reputation with our integrated PR & Marketing solutions, designed to captivate audiences and drive impactful results.",
            features: ["Social Media", "SEO/SEM", "Content Strategy", "Brand Management"],
            icon: (
                <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                </svg>
            )
        },
        {
            id: 6,
            title: "Support & Maintenance",
            description: "It is necessary once your platform is live. Our team identify and resolve issues immediately they're reported.",
            features: ["24/7 Support", "Bug Fixes", "Performance Monitoring", "Security Updates"],
            icon: (
                <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                    <path d="M12 22v-4"></path>
                    <path d="M4.93 4.93l2.83 2.83"></path>
                    <path d="M19.07 4.93l-2.83 2.83"></path>
                </svg>
            )
        }
    ];

    // Industry Solutions with SVG icons
    const industrySolutions = [
        { 
            name: "E-commerce & Retail", 
            description: "Custom online stores and shopping platforms",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
            )
        },
        { 
            name: "Education & E-Learning", 
            description: "LMS and educational portals",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
            )
        },
        { 
            name: "Healthcare & Clinics", 
            description: "Patient management and telemedicine",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                </svg>
            )
        },
        { 
            name: "Hospitality & Travel", 
            description: "Booking systems and travel portals",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="2" y1="12" x2="22" y2="12"></line>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
            )
        },
        { 
            name: "IT & SaaS Companies", 
            description: "Cloud software and enterprise solutions",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
                </svg>
            )
        },
        { 
            name: "Startups & SMEs", 
            description: "Scalable solutions for growing businesses",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                </svg>
            )
        },
        { 
            name: "Enterprise", 
            description: "Large-scale custom software solutions",
            icon: (
                <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>  </svg>
            )
        }, { 
            name: "Construction", 
            description: "Manage you construction projects with ease and efficiency",
            icon: (
               <svg className="industry-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-6 9 6v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
            )
        }
    ];

    // Why Choose Us Features with SVG icons
    const whyChooseUs = [
        { 
            title: "Expert Team", 
            description: "Dedicated professionals with years of experience",
            icon: (
                <svg className="why-choose-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            )
        },
        { 
            title: "Custom Solutions", 
            description: "Tailored to your unique business needs",
            icon: (
                <svg className="why-choose-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a10 10 0 0 0-10 10c0 4.42 3.58 8 8 8 1.46 0 2.82-.4 4-1.08"></path>
                    <circle cx="12" cy="12" r="2"></circle>
                    <path d="M16 8v8M20 8v8"></path>
                </svg>
            )
        },
        { 
            title: "Timely Delivery", 
            description: "On-time project completion guaranteed",
            icon: (
                <svg className="why-choose-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
            )
        },
        { 
            title: "Quality Assurance", 
            description: "Rigorous testing for bug-free delivery",
            icon: (
                <svg className="why-choose-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            )
        },
        { 
            title: "Affordable Pricing", 
            description: "Competitive rates with maximum value",
            icon: (
                <svg className="why-choose-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
            )
        },
        { 
            title: "24/7 Support", 
            description: "Round-the-clock technical assistance",
            icon: (
                <svg className="why-choose-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                    <line x1="8" y1="2" x2="8" y2="22"></line>
                    <line x1="16" y1="2" x2="16" y2="22"></line>
                    <line x1="2" y1="8" x2="22" y2="8"></line>
                    <line x1="2" y1="16" x2="22" y2="16"></line>
                </svg>
            )
        }
    ];

    // Process Steps with SVG icons
    const processSteps = [
        { 
            step: "01", 
            title: "Discovery", 
            description: "Requirement analysis",
            icon: (
                <svg className="process-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
            )
        },
        { 
            step: "02", 
            title: "Planning", 
            description: "Project roadmap",
            icon: (
                <svg className="process-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
            )
        },
        { 
            step: "03", 
            title: "Development", 
            description: "Build solution",
            icon: (
                <svg className="process-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                    <polyline points="2 17 12 22 22 17"></polyline>
                    <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
            )
        },
        { 
            step: "04", 
            title: "QA", 
            description: "Quality testing",
            icon: (
                <svg className="process-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            )
        },
        { 
            step: "05", 
            title: "Launch", 
            description: "Go live",
            icon: (
                <svg className="process-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                </svg>
            )
        },
        { 
            step: "06", 
            title: "Support", 
            description: "Ongoing maintenance",
            icon: (
                <svg className="process-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
            )
        }
    ];

    // WhatsApp contact info
    const whatsappNumber = "918084378326";
    const whatsappMessage = "Hello%20I%27m%20interested%20in%20your%20services.%20Can%20you%20please%20share%20more%20details%3F";
    const demoMessage = "Hello%20I%27d%20like%20to%20discuss%20a%20project%20with%20your%20team.%20Can%20you%20please%20share%20more%20details%3F";

    // WhatsApp URLs
    const whatsappContactUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
    const whatsappDemoUrl = `https://wa.me/${whatsappNumber}?text=${demoMessage}`;

    // ========== REFS FOR SCROLLING ==========
    const servicesSectionRef = useRef(null);

    // ========== DATA END ==========

    // Smooth scroll to services section
    const scrollToServices = (e) => {
        e.preventDefault();
        if (servicesSectionRef.current) {
            const targetPosition = servicesSectionRef.current.offsetTop;
            const startPosition = window.pageYOffset;
            const distance = targetPosition - startPosition;
            let startTime = null;

            const animation = (currentTime) => {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const run = easeOutCubic(Math.min(timeElapsed, 800) / 800);
                window.scrollTo(0, startPosition + distance * run);
                if (timeElapsed < 800) requestAnimationFrame(animation);
            };

            requestAnimationFrame(animation);
        }
    };

    const easeOutCubic = (t) => {
        return 1 - Math.pow(1 - t, 3);
    };

    return (
        <div className="service-page">

            {/* ========== HERO SECTION START ========== */}
            <section className="service-hero-section">
                <div className="container service-hero-container pt-5">
                    <h1 className="service-hero-title">Our Services</h1>
                    <p className="service-hero-description">
                        Comprehensive digital solutions to transform your business operations, 
                        enhance customer experiences, and drive sustainable growth.
                    </p>
                    <div className="service-hero-buttons">
                        <a 
                            href={whatsappDemoUrl}
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Enquire now via WhatsApp"
                        >
                            Enquire Now
                        </a>
                    </div>
                    <a 
                        href="#services-section"
                        className="service-hero-arrow-down" 
                        onClick={scrollToServices}
                        aria-label="Scroll to services"
                    >
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </a>
                </div>
            </section>
            {/* ========== HERO SECTION END ========== */}

            {/* ========== MAIN SERVICES SECTION START ========== */}
            <section className="services-section" id="services-section" ref={servicesSectionRef}>
                <div className="container">
                    <div className="section-header">
                        <span className="service-tag">What We Offer</span>
                        <h2 className="section-title">Comprehensive Digital Solutions</h2>
                        <p className="section-description">
                            Discover our range of expert services designed to help your business thrive in the digital age
                        </p>
                    </div>
                    <div className="services-grid">
                        {mainServices.map((service) => (
                            <div className="service-card" key={service.id}>
                                <div className="service-icon">
                                    {service.icon}
                                </div>
                                <h3 className="service-card-title">{service.title}</h3>
                                <p className="service-card-description">{service.description}</p>
                                <div className="service-features">
                                    {service.features.map((feature, idx) => (
                                        <span key={idx} className="feature-tag">{feature}</span>
                                    ))}
                                </div>
                                <a 
                                    href={whatsappContactUrl}
                                    className="service-card-cta"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`Learn more about ${service.title}`}
                                >
                                    Learn More →
                                </a>
                            </div>
                        ))}
                    </div>
                    <div className="section-contact-btn">
                        <a 
                            href={whatsappDemoUrl}
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Contact us via WhatsApp"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </section>
            {/* ========== MAIN SERVICES SECTION END ========== */}

            {/* ========== INDUSTRY SOLUTIONS SECTION START ========== */}
            <section className="industry-section">
                <div className="container">
                    <div className="section-header">
                        <span className="service-tag">Industries We Serve</span>
                        <h2 className="section-title">Tailored Solutions for Every Sector</h2>
                        <p className="section-description">
                            Industry-specific solutions designed to address unique challenges and opportunities
                        </p>
                    </div>
                    <div className="industry-grid">
                        {industrySolutions.map((industry, idx) => (
                            <div className="industry-card" key={idx}>
                                <div className="industry-icon">{industry.icon}</div>
                                <h3 className="industry-title">{industry.name}</h3>
                                <p className="industry-description">{industry.description}</p>
                            </div>
                        ))}
                    </div>
                    <div className="section-contact-btn">
                        <a 
                            href={whatsappDemoUrl}
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Contact us via WhatsApp"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </section>
            {/* ========== INDUSTRY SOLUTIONS SECTION END ========== */}

            {/* ========== WHY CHOOSE US SECTION START ========== */}
            <section className="why-choose-section">
                <div className="container">
                    <div className="section-header">
                        <span className="service-tag">Why Choose Us</span>
                        <h2 className="section-title">We Deliver Excellence</h2>
                        <p className="section-description">
                            What makes us the preferred partner for businesses worldwide
                        </p>
                    </div>
                    <div className="why-choose-grid">
                        {whyChooseUs.map((item, idx) => (
                            <div className="why-choose-card" key={idx}>
                                <div className="why-choose-icon">{item.icon}</div>
                                <h3 className="why-choose-title">{item.title}</h3>
                                <p className="why-choose-description">{item.description}</p>
                            </div>
                        ))}
                    </div>
                    <div className="section-contact-btn">
                        <a 
                            href={whatsappDemoUrl}
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Contact us via WhatsApp"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </section>
            {/* ========== WHY CHOOSE US SECTION END ========== */}

            {/* ========== PROCESS SECTION START ========== */}
            <section className="process-section">
                <div className="container">
                    <div className="section-header">
                        <span className="service-tag">Our Process</span>
                        <h2 className="section-title">How We Work</h2>
                        <p className="section-description">
                            A proven methodology to ensure successful implementation and results
                        </p>
                    </div>
                    <div className="process-grid">
                        {processSteps.map((step, idx) => (
                            <div className="process-card" key={idx}>
                                {/* <div className="process-icon">{step.icon}</div> */}
                                <div className="process-step-number">{step.step}</div>
                                <h3 className="process-title">{step.title}</h3>
                                <p className="process-description">{step.description}</p>
                                {idx < processSteps.length - 1 && <div className="process-arrow">→</div>}
                            </div>
                        ))}
                    </div>
                    <div className="section-contact-btn">
                        <a 
                            href={whatsappDemoUrl}
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Contact us via WhatsApp"
                        >
                            Enquire Now
                        </a>
                    </div>
                </div>
            </section>
            {/* ========== PROCESS SECTION END ========== */}

            {/* ========== CTA SECTION START ========== */}
            <section className="service-cta-section">
                <div className="container">
                    <h3 className="service-cta-title">Ready to Start Your Project?</h3>
                    <p className="service-cta-description">
                        Let's discuss how our services can help you achieve your business goals
                    </p>
                    <div className="service-cta-buttons">
                        <a 
                            href={whatsappDemoUrl}
                            className="btn btn-large-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Get a free quote via WhatsApp"
                        >
                            Start For Free →
                        </a>
                       
                    </div>
                </div>
            </section>
            {/* ========== CTA SECTION END ========== */}

        </div>
    );
};

export default ServicePage;